<template>
  <div id="receptionist" class="mb-2 wrrapper">
    <page-heading title="Patient Report" border></page-heading>
    <div class="header flex align-center justify-end mt-2">
      <Input
        @enter="handleSearch"
        v-model="searchText"
        type="text"
        placeholder="MR_NO"
        icon="mdi-magnify"
        :handleSearch="handleSearch"
        :handleReset="handleReset"
        :reset="searchText"
      />
      <ExportButtons
        style="margin-left: 8px;"
        @pdf="handleExportPdf"
        @excel="handleExportExcel"
      />
    </div>
    <div class="content">
      <div class="details flex space-between flex-wrap">
        <Input
          class="mb-base"
          label="Full Name"
          type="text"
          v-model="detailsPatient.name"
          disabled
        />
        <Input
          class="mb-base"
          label="Father/Husband Name"
          type="text"
          v-model="detailsPatient.fatherOrHusbandName"
          disabled
        />
        <Input
          class="mb-base"
          label="Address"
          type="text"
          v-model="detailsPatient.address"
          disabled
        />
        <Input
          class="mb-base"
          label="Contact Number"
          v-model="detailsPatient.contactNumber"
          type="text"
          disabled
        />
      </div>
      <data-table
        :cols="columns"
        :rows="reports"
        height="calc(100vh - 34.5rem)"
        :loading="loading"
      >
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu
            :rowData="actions"
            :handleItemClick="handleItems"
            :items="items"
          />
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Input from "@/components/Input";
import { downloadPdf } from "@/utils/helpers";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { mapActions, mapGetters } from "vuex";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
export default {
  components: {
    DropdownMenu,
    DataTable,
    Input,
    ExportButtons
  },
  data() {
    return {
      searchText: "",
      items: ["Print"],
      columns: [
        { column: "id", label: "#", width: "60" },
        {
          column: "patientname",
          label: "Patient Name",
          sortable: true,
          sort: true
        },
        {
          column: "comment",
          label: "Comment",
          sortable: true
        },
        {
          column: "doctor",
          label: "Prepared By",
          sortable: true
        },
        {
          column: "name",
          label: "Report",
          sortable: true
        },
        {
          column: "branch_name",
          label: "Branch Name",
          sortable: true
        },
        {
          column: "status",
          label: "Status",
          sortable: true,
          sort: true
        },
        {
          column: "created_at",
          label: "Created Date",
          sortable: true,
          sort: true
        },
        { column: "action", label: "Action", sortable: true }
      ]
    };
  },
  methods: {
    ...mapActions("receptionist", ["searchHistory", "patientDetails"]),
    handleSearch() {
      if (permissionsMiddleWare("History By Mr")) {
        const data = {
          searchText: this.searchText,
          branchId: null
        };

        this.searchHistory(data).then(() => {
          this.patientId
            ? this.patientDetails(this.patientId)
            : this.$toasted.success("No history found").goAway("3000");
        });
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: History By Mr"
          )
          .goAway("3000");
      }
    },
    handleReset() {
      this.searchText = "";
    },
    handleItems(val, rowData) {
      if (val == "Print") {
        downloadPdf(rowData.path);
        rowData.path == null
          ? this.$toasted.show("No report available").goAway("3000")
          : "";
      }
    },
    exportInput() {
      return {
        title: "Patient Report",
        subtitle: this.detailsPatient && this.detailsPatient.name,
        printedBy: this.userInfo && this.userInfo.full_name,
        cols: this.columns,
        rows: this.reports,
        fileName: "patient-medical-reports"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    }
  },
  computed: {
    ...mapGetters({
      historySearchResults: "receptionist/historySearchResults",
      detailsPatient: "receptionist/detailsPatient",
      loading: "loading",
      userInfo: "auth/userInfo"
    }),
    reports() {
      const items = this.historySearchResults || [];
      return items.filter(item => item && item.path !== null);
    },
    patientId() {
      const searchResults = this.historySearchResults || [];
      const [newArr] = [...searchResults];
      return newArr.patientId;
    }
  }
};
</script>

<style>
.content .details {
  padding: 20px 14px;
}
.content .details > div {
  flex: 0 0 30%;
  max-width: 30%;
}
#receptionist .actions .edit {
  color: var(--accent-600) !important;
}
.patient-search {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
}
#receptionist .patient-search input {
  padding: 9px 0 9px 15px;
  border: none;
  margin: 0;
  width: 200px;
}
#receptionist .footer {
  margin-right: 30px;
}
.patient-search .customInput {
  margin-bottom: 0;
}
#receptionist .patient-search span {
  color: var(--muted);
  background: var(--surface-2);
  border-left: 1px solid var(--line-strong);
  padding: 11px 15px 7px 15px;
}
#receptionist .content .table {
  border-left: none;
  border-right: none;
  border-bottom: none;
}
.add-template {
  padding: 10px 15px;
}
.template-title {
  width: 300px;
}
</style>
